import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Configuration } from '../../core/configuration/configuration';

@Component({
  selector: 'app-login-layout',
  templateUrl: './login-layout.component.html',
  styleUrls: ['./login-layout.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class LoginLayoutComponent implements OnInit {

  copyrightDate : Date = new Date();
  nombreProyecto: string;
  @Input() titulo = '';

  constructor(    ) {
    this.nombreProyecto = Configuration.proyectName;
  }

  ngOnInit() {
  }
}
